import { buildProps, definePropType } from '@ll-plus/utils'

import { type HttpModel, DEFAULT_METHOD } from './'

export const methods = [
  {
    label: 'GET',
    value: 'GET'
  },
  {
    label: 'POST',
    value: 'POST'
  },
  {
    label: 'PUT',
    value: 'PUT'
  },
  {
    label: 'DELETE',
    value: 'DELETE'
  }
]

export const apiUrlProps = buildProps({
  value: {
    type: definePropType<HttpModel>(Object),
    default: () => ({
      url: '',
      method: DEFAULT_METHOD,
      requestParams: [],
      headerParams: [],
      bodyParams: {
        type: 'none',
        parameters: [],
        jsonSchema: [],
        description: ''
      }
    })
  }
} as const)

export const apiUrlEmits = {
  'update:value': (params: HttpModel) => !!params,
  change: (params: HttpModel) => !!params
}
